App.namespace('es6.shared.performanceTracker', () => {
  const parseNumber = (number) => {
    if (!number || typeof number !== 'number' || isNaN(number)) {
      return undefined;
    }

    // if number is bigger than 1minute something went wrong getting performance API values
    if (number > 60000) {
      return undefined;
    }

    return Math.round(number);
  };

  const getFromPerformanceEntries = (entryName) => {
    let time;

    try {
      time = window.performance.getEntriesByName(entryName)[0].startTime;
    } catch (err) {}

    return parseNumber(time);
  };

  const tryGettingPerformanceMetric = (key) => {
    let timing;
    let start;

    try {
      timing = window.performance.timing;
      start = timing.navigationStart;
    } catch (err) {}

    if (!timing || !timing[key] || !start || start >= timing[key]) {
      return undefined;
    }

    return parseNumber(timing[key] - start);
  };

  const getPageRequestsMetrics = () => {
    let metrics = {};

    try {
      metrics = window.performance.getEntries().reduce((mem, el) => {
        mem.transferSize += el.transferSize || 0;
        mem.requestsCount += 1;
        return mem;
      }, {
        transferSize: 0,
        requestsCount: 0,
      });

      metrics.documentSize = window.performance.getEntriesByType('navigation')[0].encodedBodySize;
    } catch (err) {}

    return metrics;
  };

  const getPageMemoryUsage = () => {
    try {
      return window.performance.memory.usedJSHeapSize;
    } catch (err) {
      return undefined;
    }
  };

  const getDomSize = () => {
    return document.getElementsByTagName('*').length;
  };

  const onLoad = () => {
    const pageMetrics = getPageRequestsMetrics();

    const memoryUsage = getPageMemoryUsage();
    const domSize = getDomSize();

    App.track.performance({
      documentSize: pageMetrics.documentSize,
      transferSize: pageMetrics.transferSize,
      requestsCount: pageMetrics.requestsCount,
      memoryUsage,
      domSize,
      fetchStart: tryGettingPerformanceMetric('fetchStart'),
      domainLookupStart: tryGettingPerformanceMetric('domainLookupStart'),
      domainLookupEnd: tryGettingPerformanceMetric('domainLookupEnd'),
      connectStart: tryGettingPerformanceMetric('connectStart'),
      secureConnectionStart: tryGettingPerformanceMetric('secureConnectionStart'),
      connectEnd: tryGettingPerformanceMetric('connectEnd'),
      requestStart: tryGettingPerformanceMetric('requestStart'),
      ttfb: tryGettingPerformanceMetric('responseStart'),
      serverTime: tryGettingPerformanceMetric('responseEnd'),
      domInteractive: tryGettingPerformanceMetric('domInteractive'),
      domReadyStart: tryGettingPerformanceMetric('domContentLoadedEventStart'),
      domReady: tryGettingPerformanceMetric('domContentLoadedEventEnd'),
      onLoad: tryGettingPerformanceMetric('loadEventStart'),
      onLoadEnd: tryGettingPerformanceMetric('loadEventEnd'),

      firstPaint: getFromPerformanceEntries('first-paint'),
      firstContentfulPaint: getFromPerformanceEntries('first-contentful-paint'),
      vueReady: getFromPerformanceEntries('VUE_READY'),
    });
  };

  window.addEventListener('load', onLoad);

  const addPerformanceMark = (key) => {
    try {
      window.performance.mark(key);
    } catch (err) {}
  };

  return {
    addPerformanceMark,
  };
});
